import { useContext } from 'react';
import LoginModal from '@components/loginModal';
import { ChatContext, ChatContextType } from '@components/chat/ChatContext';

interface ChatLoginModalProps {
  visible: boolean;
  onClose: () => void;
}

const ChatLoginModal = ({ visible, onClose }: ChatLoginModalProps) => {
  const { channelInfo, setChannelInfo } = useContext<ChatContextType>(ChatContext);

  const getRedirectUrl = () => {
    const url = window.location.href;
    if (url.includes('?')) {
      if (url.includes('channelId')) return '';
      return `${window.location.search}&channelId=${channelInfo?.id}`;
    }
    return `?channelId=${channelInfo?.id}`;
  };

  return (
    <LoginModal
      subTitle="채용정보 · 역량검사 · 매칭까지"
      title="취업기회 지금 바로 잡다!"
      visible={visible}
      onClose={() => {
        setChannelInfo(null);
        onClose();
      }}
      redirectUrl={getRedirectUrl()}
    />
  );
};

export default ChatLoginModal;
